import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "aria-expanded": "true"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "collapse show" }
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "d-flex col-lg-8 fv-row" }
const _hoisted_11 = { class: "indicator-label" }
const _hoisted_12 = { class: "indicator-progress" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_14 = { class: "fv-plugins-message-container position-absolute top-10 start-50" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_18 = { class: "col-lg-8 fv-row" }
const _hoisted_19 = { class: "form-text" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "row mb-6" }
const _hoisted_48 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_49 = { class: "col-lg-8" }
const _hoisted_50 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_51 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill fs-6" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_create"
}, null, -1)
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "form-text" }
const _hoisted_57 = { class: "row mb-6" }
const _hoisted_58 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-8 fv-row" }
const _hoisted_60 = { class: "fv-plugins-message-container" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { class: "row mb-6" }
const _hoisted_63 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_64 = { class: "col-lg-8 fv-row" }
const _hoisted_65 = { class: "fv-plugins-message-container" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = { class: "row mb-6" }
const _hoisted_68 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_69 = { class: "col-lg-8" }
const _hoisted_70 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_71 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill fs-6" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_create"
}, null, -1)
const _hoisted_74 = { class: "fv-plugins-message-container" }
const _hoisted_75 = { class: "fv-help-block" }
const _hoisted_76 = { class: "form-text" }
const _hoisted_77 = { class: "row mb-6" }
const _hoisted_78 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_79 = { class: "col-lg-8 fv-row" }
const _hoisted_80 = { class: "fv-plugins-message-container" }
const _hoisted_81 = { class: "fv-help-block" }
const _hoisted_82 = { class: "row mb-6" }
const _hoisted_83 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_84 = { class: "col-lg-8 fv-row" }
const _hoisted_85 = { class: "fv-plugins-message-container" }
const _hoisted_86 = { class: "fv-help-block" }
const _hoisted_87 = { class: "row mb-6" }
const _hoisted_88 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_89 = { class: "col-lg-8 fv-row" }
const _hoisted_90 = { class: "fv-plugins-message-container" }
const _hoisted_91 = { class: "fv-help-block" }
const _hoisted_92 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_93 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_94 = { class: "col-lg-8 fv-row" }
const _hoisted_95 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_96 = { class: "row mb-6" }
const _hoisted_97 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_98 = { class: "col-lg-8 fv-row" }
const _hoisted_99 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_100 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_101 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_102 = { class: "col-lg-8 fv-row" }
const _hoisted_103 = { class: "fv-plugins-message-container" }
const _hoisted_104 = { class: "fv-help-block" }
const _hoisted_105 = { class: "row mb-6" }
const _hoisted_106 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_107 = { class: "col-lg-8 fv-row" }
const _hoisted_108 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_109 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_110 = {
  key: 0,
  type: "submit",
  id: "kt_package_update_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_111 = { class: "indicator-label" }
const _hoisted_112 = { class: "indicator-progress" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'blogs'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('blogsUpdating')), 1)
          ]),
          (_ctx.can('update', 'blogs'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary justify-content-end",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToBlogContent(_ctx.blogData.id)))
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.translate('updateContent')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.blogSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.translate('externalReference')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "externalReference",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid me-3",
                      placeholder: _ctx.translate('url'),
                      modelValue: _ctx.blogData.externalReference,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.blogData.externalReference) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("button", {
                      type: "submit",
                      id: "kt_account_profile_details_submit",
                      ref: "onSubmitPullDataButton",
                      class: "btn btn-primary flex-shrink-0",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmitPullData && _ctx.onSubmitPullData(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.translate('pullData')), 1),
                      _createElementVNode("span", _hoisted_12, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_13
                      ])
                    ], 512)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "externalReference" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.translate('publishedAt')) + ": ", 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_Field, {
                      type: "datetime-local",
                      name: "publishedAt",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      modelValue: _ctx.blogData.publishedAt,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.blogData.publishedAt) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.translate('blogPublishedAtHint')), 1),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "publishedAt" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('arabicTitle')) + ": ", 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('packageTitleAr'),
                      modelValue: _ctx.blogData.titleAr,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.blogData.titleAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('englishTitle')) + ": ", 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('packageTitleEn'),
                      modelValue: _ctx.blogData.titleEn,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.blogData.titleEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('descriptionAr')) + ": ", 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      name: "descriptionAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('descriptionAr'),
                      style: {"height":"150px","resize":"vertical"},
                      modelValue: _ctx.blogData.descriptionAr,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.blogData.descriptionAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_ErrorMessage, { name: "descriptionAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.translate('descriptionEn')) + ": ", 1),
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      name: "descriptionEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('descriptionEn'),
                      style: {"height":"150px","resize":"vertical"},
                      modelValue: _ctx.blogData.descriptionEn,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.blogData.descriptionEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_ErrorMessage, { name: "descriptionEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.translate('author')) + ": ", 1),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "authorName",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('authorName'),
                      modelValue: _ctx.blogData.authorName,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.blogData.authorName) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_ErrorMessage, { name: "authorName" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.translate('authorAvatar')), 1),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", {
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.authorAvatarThumbnail})`)
                      }, null, 4),
                      _createElementVNode("label", _hoisted_51, [
                        _hoisted_52,
                        _createVNode(_component_Field, {
                          type: "file",
                          name: "authorAvatar",
                          accept: ".png, .jpg, .jpeg",
                          onChange: _cache[9] || (_cache[9] = (e) => _ctx.previewImage(e, 'authorAvatar'))
                        }),
                        _hoisted_53
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_ErrorMessage, { name: "authorAvatar" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.translate('allowedFileTypes')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('sourceName')) + ": ", 1),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "sourceName",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('sourceName'),
                      modelValue: _ctx.blogData.sourceName,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.blogData.sourceName) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_ErrorMessage, { name: "sourceName" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.translate('sourceLink')) + ": ", 1),
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "sourceLink",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('sourceLink'),
                      modelValue: _ctx.blogData.sourceLink,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.blogData.sourceLink) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(_component_ErrorMessage, { name: "sourceLink" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.translate('image')), 1),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", {
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.thumbnail})`)
                      }, null, 4),
                      _createElementVNode("label", _hoisted_71, [
                        _hoisted_72,
                        _createVNode(_component_Field, {
                          type: "file",
                          name: "image",
                          accept: ".png, .jpg, .jpeg",
                          onChange: _cache[12] || (_cache[12] = (e) => _ctx.previewImage(e, 'cover'))
                        }),
                        _hoisted_73
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createVNode(_component_ErrorMessage, { name: "image" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.translate('allowedFileTypes')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.translate('relatedBlogs')), 1),
                  _createElementVNode("div", _hoisted_79, [
                    _createVNode(_component_Field, { name: "relatedIds" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: _ctx.selectedBlogsIds,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedBlogsIds) = $event))
                        }, field, {
                          mode: "tags",
                          options: _ctx.allBlogs,
                          label: "titleEn",
                          "track-by": "titleEn",
                          searchable: true,
                          placeholder: _ctx.translate('selectRelatedBlogs'),
                          "value-prop": "id",
                          "no-results-text": _ctx.translate('noResultsFound')
                        }), null, 16, ["modelValue", "options", "placeholder", "no-results-text"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createVNode(_component_ErrorMessage, { name: "blogId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.translate('tags')), 1),
                  _createElementVNode("div", _hoisted_84, [
                    _createVNode(_component_Field, { name: "tagIds" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: _ctx.selectedTagsIds,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedTagsIds) = $event))
                        }, field, {
                          mode: "tags",
                          options: _ctx.allTags,
                          label: "titleAr",
                          "track-by": "titleAr",
                          searchable: true,
                          placeholder: _ctx.translate('selectTags'),
                          "value-prop": "id",
                          "no-results-text": _ctx.translate('noResultsFound')
                        }), null, 16, ["modelValue", "options", "placeholder", "no-results-text"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createVNode(_component_ErrorMessage, { name: "blogId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.translate('categories')), 1),
                  _createElementVNode("div", _hoisted_89, [
                    _createVNode(_component_Field, { name: "categoryId" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps(field, {
                          modelValue: _ctx.blogData.categoryId,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.blogData.categoryId) = $event)),
                          options: _ctx.allBlogCategories,
                          label: "titleEn",
                          "track-by": "id",
                          searchable: true,
                          placeholder: _ctx.translate('selectCategories'),
                          "value-prop": "id",
                          "no-results-text": _ctx.translate('noResultsFound')
                        }), null, 16, ["modelValue", "options", "placeholder", "no-results-text"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _createVNode(_component_ErrorMessage, { name: "categoryId" })
                      ])
                    ])
                  ])
                ]),
                (_ctx.isArticlesCategory(_ctx.blogData.categoryId))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                      _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.translate('addToTestimonials')) + ": ", 1),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("label", _hoisted_95, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.blogData.addToTestimonials) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.blogData.addToTestimonials]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.translate('schedule')) + ": ", 1),
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("label", _hoisted_99, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isScheduled) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.isScheduled]
                      ])
                    ])
                  ])
                ]),
                (_ctx.isScheduled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                      _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.translate('scheduledAt')) + ": ", 1),
                      _createElementVNode("div", _hoisted_102, [
                        _createVNode(_component_Field, {
                          type: "datetime-local",
                          name: "scheduledAt",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          modelValue: _ctx.blogData.scheduledAt,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.blogData.scheduledAt) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_103, [
                          _createElementVNode("div", _hoisted_104, [
                            _createVNode(_component_ErrorMessage, { name: "scheduledAt" })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.translate('isFeatured')) + ": ", 1),
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("label", _hoisted_108, [
                      _createVNode(_component_Field, {
                        name: "isHomepage",
                        type: "checkbox",
                        class: "form-check-input",
                        value: true,
                        "unchecked-value": "false",
                        modelValue: _ctx.blogData.isHomepage,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.blogData.isHomepage) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                (_ctx.can('update', 'blogs'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_110, [
                      _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_112, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_113
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}